import { PropsWithChildren } from 'react';
import { Layout } from 'antd';
import { AppHeader } from 'components/Layout/Header';
import cn from './styles.module.scss';

type BaseLayoutProps = PropsWithChildren<{
  variant?: 'default' | 'fullBleed';
}>;

const BaseLayout = ({ children, variant = 'default' }: BaseLayoutProps) => {
  return (
    <Layout>
      <AppHeader />
      <Layout.Content className={variant === 'fullBleed' ? cn.fullBleed : cn.content}>
        {children}
      </Layout.Content>
    </Layout>
  );
};

export default BaseLayout;
